// localStorage persistence for the v2 mastery record. Kept out of the pure
// lib (synthMastery.js) so the logic stays testable; kept in ONE place so the
// home page and the practice player can't disagree about the key or coercion.
//
// Per-device by design for now — cross-device sync via Firestore is tracked
// in GitHub issue #91, and coerceMastery gives a sync layer a safe merge point.

import { coerceMastery, emptyMastery } from "../../lib/synthMastery";

export const MASTERY_KEY = "synthLabMasteryV2";

export const loadMastery = () => {
  try {
    return coerceMastery(JSON.parse(window.localStorage.getItem(MASTERY_KEY)));
  } catch {
    return emptyMastery();
  }
};

export const saveMastery = (mastery) => {
  try {
    window.localStorage.setItem(MASTERY_KEY, JSON.stringify(mastery));
  } catch {
    /* ignore quota / privacy-mode errors */
  }
};

export const clearMastery = () => {
  try {
    window.localStorage.removeItem(MASTERY_KEY);
  } catch {
    /* ignore */
  }
};
